module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/14ca42a8fe58eac304681f850e8de3f2.gif";